const handlers = {
  onChangePassword: (props) => (event) => {
    props.setPassword(event.target.value)
  },
  onChangeUsername: (props) => (event) => {
    props.setUsername(event.target.value)
  },
  onKeyPress: ({ submit }) => (event) => {
    if (event.charCode === 13) {
      submit()
    }
  },
  onCloseError: (props) => (event) => {
    props.loginReset()
    props.setShowErrorMessage(false)
  }
}

export default handlers
